export default __webpack_public_path__ + "static/media/Viridian Bolts.841d83ba.jpg";